import axios from 'axios';

// Ermittle die aktuelle Basis-URL (z.B. https://termin.etv-kanusport.de)
// und hänge /api an.
const API_URL = `${window.location.origin}/api`;

export const api = axios.create({
    baseURL: API_URL,
});

export const setAuthToken = (token: string) => {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
};
